import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import {
  ApiKeyVaultRootParamList,
  SettingsRootParamList,
} from "../../../../types";
import {
  createStackHeaderNavigator,
  ModalCloseButton,
} from "@towersystems/roam-common-native";
import { ApiKeyVaultListScreen } from "./ApiKeyVaultListScreen";
import { CreateNewApiVaultKeyRootScreen } from "./CreateNewApiVaultKeyRootScreen";

const Stack = createStackHeaderNavigator<ApiKeyVaultRootParamList>();

export interface ApiKeyVaultRootScreenProps
  extends StackScreenProps<SettingsRootParamList, "ApiKeyVaultRootScreen"> {}

export const ApiKeyVaultRootScreen = ({}: ApiKeyVaultRootScreenProps) => {
  return (
    <Stack.Navigator
      screenOptions={{
        animationEnabled: true,
        cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
      }}
    >
      <Stack.Group
        screenOptions={{
          title: "",
          headerLeft: () => <ModalCloseButton type="Back" />,
        }}
      >
        <Stack.Screen
          name="ApiKeyVaultListScreen"
          component={ApiKeyVaultListScreen}
        />
        <Stack.Screen
          name="CreateNewApiVaultKeyRootScreen"
          component={CreateNewApiVaultKeyRootScreen}
          options={{
            headerShown: false,
          }}
        />
      </Stack.Group>
    </Stack.Navigator>
  );
};
